<template>
  <v-app light>
    <navigation-toolbar ref="toolbar"></navigation-toolbar>
    <navigation-drawer></navigation-drawer>
    <v-main v-if="initializing">
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-progress-circular indeterminate class="primary--text" :width="5" :size="100" />
        </v-row>
      </v-container>
    </v-main>
    <v-main v-else>
      <shared-debtor-messages></shared-debtor-messages>
      <router-view></router-view>
    </v-main>
    <v-divider></v-divider>
    <navigation-footer></navigation-footer>
    <shared-privacy-consent></shared-privacy-consent>
    <shared-scroll-to-top v-if="$vuetify.breakpoint.mdAndUp"></shared-scroll-to-top>
    <shared-messager></shared-messager>
    <v-dialog v-model="missingContactInformationDialog"
              persistent
              :fullscreen="dialogSettings.fullscreen"
              :scrollable="dialogSettings.scrollable"
              :hide-overlay="dialogSettings.hideoverlay"
              :transition="dialogSettings.transition"
              :width="dialogSettings.width"
              :max-width="dialogSettings.maxwidth">
      <shared-missing-contact-information-dialog @close="missingContactInformationDialog = false"></shared-missing-contact-information-dialog>
    </v-dialog>
    <v-dialog v-model="verdictDownloadDialog"
              persistent
              :fullscreen="dialogSettings.fullscreen"
              :scrollable="dialogSettings.scrollable"
              :hide-overlay="dialogSettings.hideoverlay"
              :transition="dialogSettings.transition"
              :width="dialogSettings.width"
              :max-width="dialogSettings.maxwidth">
      <verdict-dialog :debts="verdictAvailableDebts" @close="verdictDownloadDialog = false"></verdict-dialog>
    </v-dialog>
  </v-app>
</template>

<script>
  import { mapGetters } from 'vuex'

  import HeaderToolbar from '@/components/Navigation/HeaderToolbar.vue'
  import HeaderDrawer from '@/components/Navigation/HeaderDrawer.vue'
  import Footer from '@/components/Navigation/Footer.vue'
  import moment from 'moment'
  import VerdictDialog from '@/components/Verdict/VerdictDialog.vue'

  export default {
    components: {
      'navigation-toolbar': HeaderToolbar,
      'navigation-drawer': HeaderDrawer,
      'navigation-footer': Footer,
      'verdict-dialog': VerdictDialog
    },
    data: function () {
      return {
        missingContactInformationDialog: false,
        verdictDownloadDialog: false
      }
    },
    computed: {
      ...mapGetters({
        initializing: 'initializing',
        debtor: 'debtor',
        locale: 'locale',
        userIsAuthenticated: 'authenticated',
        hidePersonalInfo: 'hidePersonalInfo',
        trackingAllowed: 'trackingAllowed',
        missingContactInformationQueried: 'missingContactInformationQueried',
        showVerdictDialogQueried: 'showVerdictDialogQueried',
        auth_type: 'auth_type',
        socSecVerified: 'socSecVerified',
        verdictAvailableDebts: 'verdictAvailableDebts',
        showVerdictSentDialog: 'showVerdictSentDialog'
      }),
      dialogSettings() {
        return {
          fullscreen: this.$vuetify.breakpoint.smAndDown,
          scrollable: false,
          hideoverlay: this.$vuetify.breakpoint.smAndDown,
          transition: this.$vuetify.breakpoint.smAndDown ? 'dialog-bottom-transition' : 'dialog-transition',
          width: this.$vuetify.breakpoint.smAndDown ? 'auto' : '1024px',
          maxwidth: this.$vuetify.breakpoint.smAndDown ? 'none' : '90%'
        }
      },
      hasEmail: function () {
        if (this.debtor !== null && this.debtor.contactInformation !== null) {
          return this.debtor.contactInformation.emails.length > 0
        } else {
          return false
        }
      },
      hasPhone: function () {
        if (this.debtor !== null && this.debtor.contactInformation !== null) {
          return this.debtor.contactInformation.phones.length > 0
        } else {
          return false
        }
      },
      hideContactInformation: function () {
        if (this.debtor !== null && this.debtor.contactInformation !== null) {
          return this.debtor.contactInformation.hideContactInformation
        } else {
          return true
        }
      },
      debtorHasMissingContactInformation: function () {
        if (Object.prototype.hasOwnProperty.call(this.debtor, 'nr')) {
          if ((!this.hasEmail || !this.hasPhone) &&
            this.hideContactInformation === false &&
            this.missingContactInformationQueried === null ||
            moment().subtract(1, 'months') >= moment(this.missingContactInformationQueried)) {
              return true
          }
        }
        return false
      },
      debtorCanDownloadVerdict: function () {
        if (Object.prototype.hasOwnProperty.call(this.debtor, 'nr')) {
          if (!this.showVerdictDialogQueried && !this.showVerdictSentDialog && this.verdictAvailableDebts.length > 0) {
            return true
          }
        }
        return false
      }
    },
    methods: {
      initNinchat: function () {
        if (Object.prototype.hasOwnProperty.call(this.debtor, 'nr')) {
          let el = document.getElementById('ninchat-iframe')
          if (el) {
            el.style.display = 'block'
          }
          let ninchatLanguage = 'finnish'

        if (this.locale === 'se') {
          ninchatLanguage = 'swedish'
        } else if (this.locale === 'en') {
          ninchatLanguage = 'english'
        } else {
          ninchatLanguage = 'finnish'
        }

        window.Ninchat.embedInit({
          configKey: process.env.VUE_APP_CONFIG_ENV === 'testing' ? 'site/1a8ua6fi00g/5t1l35u6003o8.json' : 'site/1a8ua6fi00g/4bpn5m4p00ge4.json',
          environment: [ninchatLanguage],
          audienceMetadata: {
            CustomerID: this.debtor.nr,
            URL: window.location.href,
            Referrer: document.referrer,
            Browser: navigator.userAgent,
            ScreenHeight: screen.height,
            ScreenWidth: screen.width
          }
        })
        }
      },
      closeNinchat: function () {
        let el = document.getElementById('ninchat-iframe')
        if (el) {
          window.Ninchat.close()
          el.style.display = 'none'
        }
      },
      showMissingContactInformationDialog: function () {
        if (this.debtorHasMissingContactInformation) {
          this.missingContactInformationDialog = true
          this.$matomo && this.$matomo.trackEvent("Information", "Contact Info Popup", "Show Contact Info Popup")
        }
      },
      showDownloadVerdictDialog: function () {
        if (this.debtorCanDownloadVerdict) {
          this.verdictDownloadDialog = true
          this.$matomo && this.$matomo.trackEvent("Action", "Download Court's Decision", "Decision Start")
        }
      }
    },
    watch: {
      debtor: function (val) {
        if (Object.prototype.hasOwnProperty.call(val, 'nr')) {
          if (this.trackingAllowed) {
            window._paq.push(['setUserId', val.nr])
          }
          if (this.debtorCanDownloadVerdict) {
            this.showDownloadVerdictDialog()
          } else if (this.debtorHasMissingContactInformation) {
            this.showMissingContactInformationDialog()
          }
        } else {

          if (this.trackingAllowed) {
            window._paq.push(['resetUserId'])
            window._paq.push(['appendToTrackingUrl', 'new_visit=1']);
            window._paq.push(['trackEvent', 'Action', 'Reset UserNr', 'Reset UserNr'])
            window._paq.push(['appendToTrackingUrl', '']);
          }
        }
      },
      showVerdictSentDialog: function (val, oldVal) {
        if (!oldVal && val) {
          this.verdictDownloadDialog = false
        }
      }
    }
  }
</script>
